import React from "react"
import { ArrayFieldTemplateProps } from "@rjsf/core"
import { Button, Text, ValidationError } from "dash-styled"
import { ReactComponent as TrashIcon } from "icons/lib/trash.svg"
import { ReactComponent as AddIcon } from "icons/lib/plus.svg"
import { Table } from "resha"

type ChoicesParameterTemplateWithErrorsProps = ArrayFieldTemplateProps & {
    rawErrors?: string[]
}

export const ChoicesParameterTemplate = ({
    readonly,
    disabled,
    canAdd,
    rawErrors,
    items,
    onAddClick
}: ChoicesParameterTemplateWithErrorsProps) => {
    return (
        <div>
            <Text weight="semibold">
                Choices {items.length > 0 ? `(${items.length})` : ""}
            </Text>
            {Boolean(items.length) && (
                <Table
                    className="-ml-4 my-4"
                    style={{
                        width: "calc(100% + 2rem)"
                    }}
                    getKey={item => item.key}
                    items={items}
                    rowBgColor=""
                    columns={[
                        {
                            className: "w-1/2 pl-4",
                            headerClassName: "bg-transparent",
                            renderHeader: () => null,
                            render: item => {
                                return item.children
                            }
                        },
                        {
                            className: "w-1/6 pr-4",
                            headerClassName: "bg-transparent",
                            renderHeader: () => null,
                            render: item => {
                                return (
                                    !disabled &&
                                    !readonly && (
                                        <div className="flex items-center justify-around border-l">
                                            <Button
                                                className="w-auto"
                                                variant="text"
                                                marginLeft="2"
                                                onClick={item.onDropIndexClick(
                                                    item.index
                                                )}
                                            >
                                                <TrashIcon className="w-5 h-5" />
                                            </Button>
                                        </div>
                                    )
                                )
                            }
                        }
                    ]}
                />
            )}
            {rawErrors?.map((error, i) => (
                <ValidationError key={i} className="mr-1">
                    {error === "is a required property"
                        ? "Please fill this out"
                        : error}
                </ValidationError>
            ))}
            {canAdd && !disabled && !readonly && (
                <Button
                    className="mt-4 flex items-center"
                    size="xs"
                    color="violet"
                    variant="text"
                    onClick={onAddClick}
                >
                    <AddIcon className="mr-2" />
                    Add new choice
                </Button>
            )}
        </div>
    )
}
